// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".languagePicker_languages__1oVdw {\n  text-align: center;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  width: 70%;\n}\n\n.languagePicker_title__30T4F {\n  display: flex;\n  align-items: center;\n  font-size: 0.875rem;\n  line-height: 16px;\n  padding: 15px 26%;\n  text-transform: uppercase;\n}\n.languagePicker_title__30T4F:nth-child(even) {\n  border-left: 1px solid var(--white-30);\n}\n.languagePicker_title__30T4F img {\n  margin: 0 1em;\n}\n\n.languagePicker_flag__1oGCr {\n  margin-right: 0.8rem;\n  flex-shrink: 0;\n}", ""]);
// Exports
exports.locals = {
	"languages": "languagePicker_languages__1oVdw",
	"title": "languagePicker_title__30T4F",
	"flag": "languagePicker_flag__1oGCr"
};
module.exports = exports;
